import { render, staticRenderFns } from "./BioTestingQuizResults.vue?vue&type=template&id=3742cc77"
import script from "./BioTestingQuizResults.vue?vue&type=script&lang=js"
export * from "./BioTestingQuizResults.vue?vue&type=script&lang=js"
import style0 from "./BioTestingQuizResults.vue?vue&type=style&index=0&id=3742cc77&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports